import { Component } from '@angular/core';

import { AdminsAvatarsComponent } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { IconContainerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-templates-welcome',
  template: `
    <rt-icon-container
      name="send"
      color="colorIconPrimaryDefault"
      background="colorBgPrimarySubduedDefault"
      size="small"
      containerSize="large"
      margin-right-small
    />
    <span text-small text-darkest text-weight-semi-bold>
      {{ 'tlc.ask_hr.forms.chat.welcome_heading' | translate }}
    </span>

    <rt-admins-avatars margin-left-auto />
  `,
  imports: [IconContainerComponent, AdminsAvatarsComponent, TranslatePipe],
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
      }
    `,
  ],
})
export class TemplatesWelcomeComponent {}
